import service from "@/utils/request";

/** 获取首页 banner 列表*/
export function getBannerListWithHomeBanner(data) {
  return service({
    url: "/service/admin/bannerList",
    method: "get",
    params: { ...data, type: "homeBanner" },
  });
}

/** 获取首页 banner 详情*/
export function getBannerDetailWithHomeBanner(data) {
  return service({
    url: "/service/admin/bannerView",
    method: "get",
    params: { ...data, type: "homeBanner" },
  });
}

/** 新增首页 banner */
export function addBannerWithHomeBanner(data) {
  return service({
    url: "/service/admin/addBanner",
    method: "post",
    params: { ...data, type: "homeBanner" },
  });
}

/** 修改首页 banner */
export function editBannerWithHomeBanner(data) {
  return service({
    url: "/service/admin/editBanner",
    method: "post",
    params: { ...data, type: "homeBanner" },
  });
}

/** 快捷修改首页 banner 状态*/
export function editBannerStatusWithHomeBanner(data) {
  return service({
    url: "/service/admin/bannerSetStatus",
    method: "post",
    params: { ...data, type: "homeBanner" },
  });
}

/** 删除首页 banner */
export function deleteBannerWithHomeBanner(data) {
  return service({
    url: "/service/admin/bannerDelete",
    method: "post",
    params: { ...data, type: "homeBanner" },
  });
}

/** 获取首页金刚区列表*/
export function getBannerListWithHomeKingKong(data) {
  return service({
    url: "/service/admin/bannerList",
    method: "get",
    params: { ...data, type: "homeKingKong" },
  });
}

/** 获取首页金刚区详情*/
export function getBannerDetailWithHomeKingKong(data) {
  return service({
    url: "/service/admin/bannerView",
    method: "get",
    params: { ...data, type: "homeKingKong" },
  });
}

/** 新增首页金刚区*/
export function addBannerWithHomeKingKong(data) {
  return service({
    url: "/service/admin/addBanner",
    method: "post",
    params: { ...data, type: "homeKingKong" },
  });
}

/** 修改首页金刚区*/
export function editBannerWithHomeKingKong(data) {
  return service({
    url: "/service/admin/editBanner",
    method: "post",
    params: { ...data, type: "homeKingKong" },
  });
}

/** 快捷修改首页金刚区状态*/
export function editBannerStatusWithHomeKingKong(data) {
  return service({
    url: "/service/admin/bannerSetStatus",
    method: "post",
    params: { ...data, type: "homeKingKong" },
  });
}

/** 删除首页金刚区*/
export function deleteBannerWithHomeKingKong(data) {
  return service({
    url: "/service/admin/bannerDelete",
    method: "post",
    params: { ...data, type: "homeKingKong" },
  });
}


/** 获取体彩金刚区列表*/
export function getBannerListWithLotteryTicket(data) {
  return service({
    url: "/service/admin/bannerList",
    method: "get",
    params: { ...data, type: "lotteryTicket" },
  });
}

/** 获取体彩金刚区详情*/
export function getBannerDetailWithLotteryTicket(data) {
  return service({
    url: "/service/admin/bannerView",
    method: "get",
    params: { ...data, type: "lotteryTicket" },
  });
}

/** 新增体彩金刚区*/
export function addBannerWithLotteryTicket(data) {
  return service({
    url: "/service/admin/addBanner",
    method: "post",
    params: { ...data, type: "lotteryTicket" },
  });
}

/** 修改体彩金刚区*/
export function editBannerWithLotteryTicket(data) {
  return service({
    url: "/service/admin/editBanner",
    method: "post",
    params: { ...data, type: "lotteryTicket" },
  });
}

/** 快捷修改体彩金刚区状态*/
export function editBannerStatusWithLotteryTicket(data) {
  return service({
    url: "/service/admin/bannerSetStatus",
    method: "post",
    params: { ...data, type: "lotteryTicket" },
  });
}

/** 删除体彩金刚区 */
export function deleteBannerWithLotteryTicket(data) {
  return service({
    url: "/service/admin/bannerDelete",
    method: "post",
    params: { ...data, type: "lotteryTicket" },
  });
}

/** 获取体彩轮播列表*/
export function getBannerListWithLotteryTicketBanner (data) {
  return service({
    url: "/service/admin/bannerList",
    method: "get",
    params: { ...data, type: "lotteryBanner" },
  });
}

/** 获取体彩轮播详情*/
export function getBannerDetailWithLotteryTicketBanner(data) {
  return service({
    url: "/service/admin/bannerView",
    method: "get",
    params: { ...data, type: "lotteryBanner" },
  });
}

/** 新增体彩轮播*/
export function addBannerWithLotteryTicketBanner(data) {
  return service({
    url: "/service/admin/addBanner",
    method: "post",
    params: { ...data, type: "lotteryBanner" },
  });
}

/** 修改体彩轮播*/
export function editBannerWithLotteryTicketBanner(data) {
  return service({
    url: "/service/admin/editBanner",
    method: "post",
    params: { ...data, type: "lotteryBanner" },
  });
}

/** 快捷修改体彩轮播状态*/
export function editBannerStatusWithLotteryTicketBanner(data) {
  return service({
    url: "/service/admin/bannerSetStatus",
    method: "post",
    params: { ...data, type: "lotteryBanner" },
  });
}

/** 删除体彩轮播 */
export function deleteBannerWithLotteryTicketBanner(data) {
  return service({
    url: "/service/admin/bannerDelete",
    method: "post",
    params: { ...data, type: "lotteryBanner" },
  });
}
